import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import axios from 'axios'
import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import actionTypes from '../../action-types'
import awaitAccessToken from '../../modules/awaitAccessToken'
import addUserGroups from '../../actions/userGroups/addUserGroups'

const onFetchUserGroups = function* onFetchUserGroups() {
  yield takeLatest(actionTypes.USER_GROUPS.FETCH_ALL, function* onFetchUserGroupsSaga(action) {
    const accessToken = yield call(awaitAccessToken)

    const {
      payload: { customerProductId, badgeId },
    } = action

    const params = {
      page: 1,
      limit: 999999999,
      deletedAt: 'null:null',
      userGroupBadgeId: badgeId || undefined,
    }

    let response
    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.users}/user-groups/customer-products/${customerProductId}`,
        params,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-Infowijs-Client': 'nl.infowijs.admin',
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
        },
      })
    } catch (e) {
      rejectAction(action, e.response.data && e.response.data.errors)
      return
    }

    yield put(addUserGroups(
      customerProductId,
      response.data.data || [],
      response.data.meta,
      response.data.included || [],
    ))

    acceptAction(action, response.data.data || [])
  })
}

export default onFetchUserGroups
